// api/razorpay.js
import { getAuthToken } from "./auth"; // adjust path as needed
// ─── All Razorpay & API utilities (no UI / no JSX) ───────────────────────────

// ─── Load Razorpay SDK ────────────────────────────────────────────────────────
export const loadRazorpayScript = () =>
  new Promise((resolve) => {
    if (document.getElementById("razorpay-sdk")) return resolve(true);
    const script = document.createElement("script");
    script.id = "razorpay-sdk";
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });

// ─── API base URL ─────────────────────────────────────────────────────────────
const API_BASE =
  process.env.REACT_APP_API_URL || "https://stage.getrevibe.app/api";


// ─── Generic authenticated POST ───────────────────────────────────────────────
export const postRequest = async (url, body) => {
  const token = getAuthToken();
  if (!token) throw new Error("User not authenticated");

  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok)
    throw new Error(data?.message || data?.error || "Something went wrong");
  return data;
};

// ─── API service ──────────────────────────────────────────────────────────────
export const apiService = {
  createOrder: (orderData) => postRequest(`${API_BASE}/orders`, orderData),
  verifyPayment: (data) => postRequest(`${API_BASE}/orders/verify`, data),
};

// ─── Convert paise → rupees when value looks like paise (> 10 000) ────────────
export const convertToRupees = (value) => {
  if (value > 10000) return Math.round(value / 100);
  return Math.round(value);
};